<div class="confirmation-modal">
    <img class="mos-bg-img-block review-img-bg" src="/XpressApp/assets/images/merchant/approve.svg" />
    <h2>Your about to approve this Store/s?</h2>
     <p>Are you sure you want to proceed?</p>
    <div class="button-container">
        <button pButton pRipple type="button" label="Cancel" class="p-button-text" (click)="ref.close(false)" [disabled]="loading"></button>
        <button pButton pRipple type="button" [label]="loading ? 'Activating...' : 'Yes, Activate'" class="p-button-primary" (click)="onConfirm()" [disabled]="loading">
            <i *ngIf="loading" class="pi pi-spin pi-spinner" style="margin-right: 0.5rem"></i>
        </button>
    </div>
</div> 